import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { StyledReactDatePicker } from './styles';
import './styles.css';

const DatePicker = ({ value, onChange, invalid, className, ...props }) => {
  const [dateValue, setDateValue] = useState(value);

  useEffect(() => {
    setDateValue(value);
  }, [value]);

  const handleChange = eventValue => {
    setDateValue(eventValue);
    if (onChange) onChange(eventValue);
  };

  return (
    <StyledReactDatePicker
      {...props}
      $invalid={Boolean(invalid)}
      className={['form-control', 'date-picker', className]
        .filter(Boolean)
        .join(' ')}
      value={dateValue}
      onChange={handleChange}
    />
  );
};

DatePicker.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Date),
  ]),
  onChange: PropTypes.func,
  invalid: PropTypes.any,
  className: PropTypes.string,
};

DatePicker.defaultProps = {
  value: '',
  onChange: undefined,
  invalid: null,
  className: '',
};

export default DatePicker;
